module.exports = __webpack_public_path__ + "img/slide6.83dc2016.png";